<template>
  <div class="cn">
    <v-container grid-list-xl fluid>
      <v-layout wrap row>
        <v-flex xs12>
          <Title title="Customer Credit note">
            <div slot="widget-content">
              <div>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color:#0cabc2">Action</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs2>
                    <v-dialog
                      v-model="new_cn_dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <v-btn color="primary" slot="activator">New Credit note</v-btn>

                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-toolbar-title>New CN</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="new_cn_dialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <new_cn @update="getCNList_date_picker()"></new_cn>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>

                <v-layout wrap row>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color:#0cabc2">Previous Credit Note</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="customer"
                      :items="customerList"
                      item-text="name"
                      item-value="name"
                      label="Customer"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs6></v-flex>
                  <v-flex xs6>
                    <datepicker ref="datepicker" @update="getCNList_date_picker()"></datepicker>
                  </v-flex>
                </v-layout>

                <v-data-table
                  :headers="cn_headers"
                  :items="cnList"
                  :search="customer"
                  :disable-initial-sort="true"
                  hide-actions
                  active-class="highlighted"
                  class="elevation-5"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td class="text-xs">
                        <b>CN{{ props.item.cn_id }}</b>
                      </td>
                      <td class="text-xs">
                        <b>{{ props.item.created_at }}</b>
                      </td>
                      <td class="text-xs">
                        <b>{{ props.item.customer_name }}</b>
                      </td>
                        <td class="text-xs">
                            <v-chip
                          outline
                          x-large
                          :color="(props.item.invoice_status == '0' ? '#48b24ff2' : props.item.invoice_status == '1' ? '#ff0000a6' : '#48b24ff2' )"
                        >{{ (props.item.invoice_status == '0' ? 'no invoice' : props.item.invoice_status == '1' ? 'invoiced' : 'invoiced' ) }}</v-chip>
                      </td>
                      <td class="text-xs">
                        <b>{{ props.item.remark }}</b>
                      </td>
                      <td class="text-xs">
                        <v-btn
                          @click="fetch_array_for_print(props.item.cn_id,props.item.customer_name,props.item.remark, 
                         props.item.created_at)"
                        >print</v-btn>
                      </td>
                      <td class="text-xs">
                        <v-icon
                          medium
                          color="warning"
                          @click="get_cn_detail(props.item.cn_id)"
                        >build</v-icon>
                        <v-icon
                          medium
                          color="error"
                          @click="delete_cn(props.item.cn_id)"
                        >delete_forever</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </div>
          </Title>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="cn_item_dialog">
      <v-card>
        <v-card-title>
          <span class="headline">DO Details</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <cn_table ref="cn_table" @update="getCNList_date_picker()"></cn_table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="cn_item_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="5000">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import Title from "@/components/widget/title_red";
import new_cn from "@/views/Create_cn";
import cn_table from "@/components/large_component/cn_table";

import * as jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import datepicker from "@/components/widget/datepicker";

export default {
  components: {
    datepicker,
    Title,
    new_cn,
    cn_table
  },
  data: () => ({
    //data
    customer: "",
    date: moment().format("YYYY-MM-DD"),
    start_date: moment()
      .startOf("month")
      .format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
    // array
    cnList: [],
    cn_headers: [
      { text: "ID", align: "", value: "cn_id" },
      { text: "Date", align: "", value: "created_at" },
      { text: "Customer", align: "", value: "customer_name" },
      { text: "status", align: "", value: "status" },
      { text: "Remark", align: "", value: "remark" },
      { text: "Print", align: "", value: "print" },
      { text: "Action", align: "", value: "" }
    ],
    baseUrl: baseUrl,
    customerList: [],
    stock: [],

    // others
    response_detail: "",
    error: "",
    VegeLogo: "",

    // dialog snackbar date_box
    cn_item_dialog: false,
    new_cn_dialog: false,
    snackbar_response: false,
    snackbar_no_connection: false
  }),

  computed: {},

  watch: {},

  created() {
    this.getImageLogo();
    this.getCustomer();
    this.getCNList(this.start_date, this.end_date);
    // this.getCompanyInfo();
  },

  methods: {
    getCustomer() {
    
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.customerList = response.data.data;
            console.log(this.customerList);
          } else if (response.data.error == true) {
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getCNList_date_picker() {
      this.getCNList(this.$refs.datepicker.date1, this.$refs.datepicker.date2);
    },
    getCNList(start_date, end_date) {
          console.log("siao haha");

      const params = new URLSearchParams();
      params.append("getCNList", "getCNList");
      //   params.append("start_date", this.date);
      //   params.append("start_date", this.date);

      params.append("start_date", start_date);
      params.append("end_date", end_date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
        data: params
      })
        .then(response => {
          console.log("siao liao");
          console.log(response);
          if (response.data.error == false) {
            this.cnList = response.data.data;
            this.errors = "error";
          } else if (response.data.error == true) {
            this.cnList = [];
            this.errors = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_no_connection = true;
        });
    },
    delete_cn(cn_id) {
      if (confirm("Delete CN?")) {
        const params = new URLSearchParams();
        params.append("deleteCN", "deleteCN");
        params.append("cn_id", cn_id);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
          data: params
        })
          .then(response => {
            if (response.data.error == false) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
              this.getCNList();
            } else if (response.data.error == true) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_no_connection = true;
          });
      }
    },
    get_cn_detail(cn_id) {
      this.$refs.cn_table.getDOStock(cn_id);
      this.cn_item_dialog = true;
    },
    getImageLogo() {
      const toDataURL = url =>
        fetch(url)
          .then(response => response.blob())
          .then(
            blob =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      toDataURL(require("@/assets/image/vege_trading.jpg")).then(dataUrl => {
        this.VegeLogo = dataUrl;
      });
    },
    getCompanyInfo() {
      const params = new URLSearchParams();
      params.append("get_company_info", "get_company_info");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.name = response.data.name;
            this.address = response.data.address;
            this.phone = response.data.phone;
            this.fax = response.data.fax;
            this.setting_grade = response.data.setting_grade;
            this.setting_location = response.data.setting_location;
            this.setting_price = response.data.setting_price;
            this.stocked_day_limit = response.data.stocked_day_limit;
          } else if (response.data.error == true) {
            console.log("gg");
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_array_for_print(cn_id, customer_name, remark, date) {
      var total_amount = 0;

      const params = new URLSearchParams();

      params.append("getCNDetail", "getCNDetail");
      params.append("cn_id", cn_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_cn.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.stock = response.data.data;

            for (var i = 0; i < this.stock.length; i++) {
              var row_amount =
                this.stock[i].weight *
                this.stock[i].price *
                this.stock[i].quantity;

              var total_weight = this.stock[i].weight * this.stock[i].quantity;

              this.$set(this.stock[i], "total_weight", total_weight);

              this.$set(
                this.stock[i],
                "amount",
                parseFloat(row_amount).toFixed(2)
              );

              this.$set(this.stock[i], "row_no", i + 1);

              total_amount += row_amount;
            }
            console.log(this.stock);
            this.print_cn(cn_id, customer_name, remark, date, total_amount);
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    print_cn(cn_id, customer_name, remark, date, total_amount) {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(15, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "NO: ");
      doc.text(158, 20, "Date: ");
      doc.text(153, 25, "Farmer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#CN" + cn_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(customer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(14);
      doc.setFontStyle("bold");
      doc.setTextColor(255, 0, 0);
      doc.text(15, 45, "#Credit Note");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.setTextColor(0, 0, 0);
      doc.text(50, 45, "Reason :");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(68, 45, remark);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Total kg/box", dataKey: "total_weight" },
        { header: "Price", dataKey: "price" },
        { header: "Amount", dataKey: "amount" }
      ];

      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };

      if (localStorage.setting_location == "true") {
        invoice_pdf_header.splice(2, 0, location_array);
      }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(2, 0, grade_array);
      }

      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",
        showHead: "firstPage",
        headStyles: {
          fillColor: [255, 230, 230],
          textColor: 10,
          fontSize: 11
        },

        columnStyles: {
          row_no: { columnWidth: 8, fontStyle: "bold" },
          product_name: { columnWidth: 25, fontStyle: "bold" },
          grade: { columnWidth: 15 },
          location: { columnWidth: 15 },
          weight: { columnWidth: 15 },
          quantity: { columnWidth: 15, fontStyle: "bold" },
          price: { columnWidth: 15, fontStyle: "bold" },
          total_weight: { columnWidth: 15, fontStyle: "bold" },
          amount: { columnWidth: 15, fontStyle: "bold" }
        },
        columns: invoice_pdf_header,
        body: this.stock
      });
      //////after auto table

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(
        140,
        doc.autoTable.previous.finalY + 10,
        "Total Amount: RM" + parseFloat(total_amount).toFixed(2)
      );

      var invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Total kg/box", dataKey: "total_weight" },
        { header: "Price", dataKey: "price" },
        { header: "Amount", dataKey: "amount" }
      ];

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      doc.save("cn.pdf");
    }
  },
  mounted() {}
};
</script>

